var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "profile-modal",
      attrs: { visible: _vm.dialogVisibility, width: "40%", top: "10px" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibility = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", { staticStyle: { "font-size": "1.2em", margin: "0px" } }, [
            _vm._v("\n      Create new Profile\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "new-device-profile",
          attrs: { model: _vm.newDevice, rules: _vm.rules },
        },
        [
          _vm.errors
            ? _c(
                "div",
                _vm._l(_vm.errors, function (error, index) {
                  return _c(
                    "el-alert",
                    {
                      key: index,
                      staticStyle: { "margin-top": "3px" },
                      attrs: { type: "error" },
                    },
                    [_vm._v("\n        " + _vm._s(error) + "\n      ")]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Product", prop: "kind" } },
            [
              _c("RefreshProducts", { staticStyle: { float: "right" } }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "Select one product",
                    clearable: "",
                    filterable: "",
                  },
                  on: { change: _vm.setProductOptions },
                  model: {
                    value: _vm.newDevice.kind,
                    callback: function ($$v) {
                      _vm.$set(_vm.newDevice, "kind", $$v)
                    },
                    expression: "newDevice.kind",
                  },
                },
                _vm._l(_vm.devices, function (product) {
                  return _c("el-option", {
                    key: product.id,
                    attrs: { label: product.description, value: product.kind },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              class: { "is-required": _vm.primaryIdentifier },
              attrs: { label: _vm.deviceIdLabel, prop: "device_id" },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.newDevice.device_id,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.newDevice,
                      "device_id",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "newDevice.device_id",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Serial Number/SMSN", prop: "serial_number" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.newDevice.serial_number,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.newDevice,
                      "serial_number",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "newDevice.serial_number",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.noProductColors
            ? _c(
                "el-form-item",
                { attrs: { label: "Color", prop: "color" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "please select color",
                        disabled: _vm.noProductColors,
                      },
                      model: {
                        value: _vm.newDevice.color,
                        callback: function ($$v) {
                          _vm.$set(_vm.newDevice, "color", $$v)
                        },
                        expression: "newDevice.color",
                      },
                    },
                    _vm._l(_vm.productColors, function (color) {
                      return _c("el-option", {
                        key: color.abbr,
                        attrs: { label: color.name, value: color.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.working },
                  on: {
                    click: function ($event) {
                      return _vm.validateForm()
                    },
                  },
                },
                [_vm._v("\n        Create Profile\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeForm()
                    },
                  },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }